const doc = [({"da":({"js":({"admin":({"agendas":({"live_button":({"the_agenda_was_saved":"Dagsordenen blev gemt", "show_in_live":"Vis i live"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;